import { Box } from "@mui/material";

import styled from "styled-components";

export const StyledCopyButton = styled(Box)<{ $copied?: boolean }>`
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: ${({ $copied }) => ($copied ? "#2e7d32" : "#ffffff")};
    border: 1px solid ${({ $copied }) => ($copied ? "#2e7d32" : "#e5e5ea")};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${({ $copied }) => ($copied ? "#ffffff" : "#6e6e73")};
    flex-shrink: 0;
    transition:
        background 150ms ease,
        border-color 150ms ease,
        color 150ms ease;

    &:hover {
        border-color: ${({ $copied }) => ($copied ? "#2e7d32" : "#ed6c02")};
        color: ${({ $copied }) => ($copied ? "#ffffff" : "#ed6c02")};
    }

    svg {
        font-size: 16px;
    }
`;
